module.exports = __webpack_public_path__ + "images/patterns/dark/BrickHorizontal.cf0169751ef925310e92.svg";